import React from 'react';
import '../styles/Footer.css';
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
function Footer() {
  const currentYear = new Date().getFullYear();


  return (
    <footer className="footer">
      <div className="footer-container">
        
        <div className="footer-content">
          <div className="footer-section">
            <h3>Planbanalo</h3>
            <p>Transforming lives through wellness and adventure</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/retreats">Yoga Retreat</a></li>
              <li><a href="/camping">Camping</a></li>
              <li><a href="/about">About Us</a></li>             
              {/* <li><a href="/contactus">Contact</a></li> */}
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>Email: planbanalo@gmail.com</p>
            <p>Phone: +91 88005 77221</p>
            
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <div style={{ display: "flex", gap: "16px" }}>

                {/* Facebook */}
                <a
                  href="https://www.facebook.com/share/1CAs3k9BuC/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background: "#1877F2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px) scale(1.08)";
                    e.currentTarget.style.boxShadow = "0 6px 18px rgba(24,119,242,0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.15)";
                  }}
                >
                  <FaFacebook size={18} />
                </a>

                {/* Instagram */}
                <a
                  href="https://www.instagram.com/_planbanalo_?igsh=YjQ2am5sNXg5MWZ3"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px) scale(1.08)";
                    e.currentTarget.style.boxShadow = "0 6px 18px rgba(221,42,123,0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.15)";
                  }}
                >
                  <FaInstagram size={18} />
                </a>



                <a
                  href="https://youtube.com/@planbanalo?si=XfEr2_WhBmqOb_fH"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background: "#FF0000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                    textDecoration: "none"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px) scale(1.08)";
                    e.currentTarget.style.boxShadow = "0 6px 18px rgba(255,0,0,0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.15)";
                  }}
                >
                  <FaYoutube size={18} />
                </a>
              </div>

            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Planbanalo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
